// Browser DynamicMixer: input → dry + convolver (synthetic IR per environment) → limiter → destination, driven by params.mix
export function createWebMixBus(ctx, input) {
  const dry = ctx.createGain(); const wet = ctx.createGain(); const conv = ctx.createConvolver(); const lim = ctx.createDynamicsCompressor();
  lim.threshold.value = -1; lim.knee.value = 0; lim.ratio.value = 20; lim.attack.value = 0.003; lim.release.value = 0.05;
  wet.gain.value = 0;
  input.connect(dry); input.connect(conv); conv.connect(wet); dry.connect(lim); wet.connect(lim); lim.connect(ctx.destination);
  let space = null;
  const impulse = (decay, damping) => {
    const sr = ctx.sampleRate; const n = Math.floor(sr * Math.min(8, decay * 1.2)); const buf = ctx.createBuffer(2, n, sr);
    for (let ch = 0; ch < 2; ch++) {
      const d = buf.getChannelData(ch); let lp = 0; const a = 0.2 + damping * 0.75;
      for (let i = 0; i < n; i++) { const env = Math.exp(-6.91 * i / (decay * sr)); const noise = (Math.random() * 2 - 1) * env; lp = a * lp + (1 - a) * noise; d[i] = noise * (1 - damping) + lp * damping; }
    }
    return buf;
  };
  const update = (mix) => {
    const t = ctx.currentTime; const r = mix?.reverb;
    if (r?.space) {
      if (space !== r.space) { conv.buffer = impulse(r.decay || 2, r.damping ?? 0.5); space = r.space; }
      wet.gain.linearRampToValueAtTime(r.mix * 1.6, t + 0.5); dry.gain.linearRampToValueAtTime(1 - r.mix, t + 0.5);
    } else { wet.gain.linearRampToValueAtTime(0, t + 0.5); dry.gain.linearRampToValueAtTime(1, t + 0.5); }
    if (mix?.limiter) lim.threshold.value = mix.limiter.ceiling_db ?? -1;
  };
  return { update };
}
